import { createSelector } from 'reselect'

export const getCustomerAddresses = state => state.customerAddresses.getIn(['all', 'objects'])

export const createGetCustomerAddressByIDSelector = id =>
    createSelector([getCustomerAddresses], customerAddresses => customerAddresses.get(String(id)))

const getCurrentCustomerAddressStatus = state => state.customerAddresses.get('current')

export const createGetCurrentCustomerAddressStatusSelector = () => createSelector([getCurrentCustomerAddressStatus], status => status)

export const getCustomerAddressDeleting = state => state.customerAddresses.getIn(['deletion', 'inProgress'])

export const getCustomerAddressDeleteError = state => state.customerAddresses.getIn(['deletion', 'error'])

const getDuplicity = state => state.customerAddresses.getIn(['all', 'duplicity'])

export const createGetDuplicitySelector = () => createSelector([getDuplicity], duplicity => duplicity)

export const getFoundAddresses = state => state.customerAddresses.getIn(['finding', 'objects'])
export const getFoundAddressesFetching = state => state.customerAddresses.getIn(['finding', 'fetching'])
export const getFoundAddressesError = state => state.customerAddresses.getIn(['finding', 'error'])
